import React from 'react';
import './CheckBox.scss';
import classnames from 'classnames';
import queryString from "query-string";
import { useLocation } from "react-router-dom";

const CheckBox = React.forwardRef((props, ref) => {
    const { search } = useLocation();
    const values = queryString.parse(search);

    const onButtonClick = (event) => {
        const insideButton = event.currentTarget.querySelector('input[type=checkbox]');
        if (insideButton) {
            insideButton.click();
        }
    };

    return (
        <div className="fieldContainer">
            <button type="button" className={classnames({
                "checkboxContainer": true,
                [props.className]: props.className,
            })} onClick={onButtonClick}>
                <input
                    type="checkbox"
                    id={(props.id || null)}
                    name={(props.id || null)}
                    checked={typeof props.checked !== 'undefined' ? Boolean(props.checked) : undefined}
                    onChange={props.onChange || null}
                    ref={ref}
                />
                <span className={classnames({
                    "aka-label": true,
                    [props.className]: props.className,
                })}>
                    <span className={`labelValue ${values.style ? `labelValue--${values.style}` : ""}`}>{props.label || props.children || ''}
                    </span>
                </span>
            </button>
        </div>
    )
});

export default CheckBox;